<template>
  <hm-content title="门店列表">
    <div slot="header">
      <hm-step :steps="steps" :step="1"></hm-step>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddStore"
          >新增门店</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="name"
          placeholder="输入门店名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="storeList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="门店名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="contacts"
          label="联系人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="contactInfo"
          label="联系方式"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="address"
          label="地址"
        ></el-table-column>
        <!-- <el-table-column header-align="center"
                         align="center"
                         prop="latitude"
                         label="纬度"></el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         prop="longitude"
                         label="经度"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="备注"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="经营状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 0 ? "关闭" : "开启" }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="预约状态">
          <template slot-scope="scope">
            <span>{{ scope.row.orderStatus === 0 ? "关闭" : "开启" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTimeFormat"
          width="140px"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="copy(scope.row)"
              >复制</el-button
            >
            <el-button type="text" size="small" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="storeList.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="新增门店"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="门店名称：" prop="name">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="contacts">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.contacts"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="contactInfo">
          <el-input
            size="small"
            @mousewheel.prevent.native
            clearable
            placeholder="输入手机号或电话号码"
            v-model.trim="ruleForm.contactInfo"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店地址：" prop="address">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.address"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店纬度：" prop="latitude">
          <div class="flex">
            <el-input
              size="small"
              @mousewheel.prevent.native
              type="number"
              clearable
              placeholder="请输入腾讯地图纬度,用于导航"
              v-model.trim="ruleForm.latitude"
            ></el-input>
            <div class="link">
              <a href="https://lbs.qq.com/tool/getpoint/" target="_blank"
                >去查询经纬度</a
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="门店经度：" prop="longitude">
          <el-input
            size="small"
            @mousewheel.prevent.native
            type="number"
            clearable
            v-model.trim="ruleForm.longitude"
            placeholder="请输入腾讯地图经度,用于导航"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            size="small"
            type="textarea"
            clearable
            v-model.trim="ruleForm.description"
          ></el-input>
        </el-form-item>
        <el-form-item label="经营状态：">
          <div class="flex item-center">
            <el-switch
              style="display: block"
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <span class="form-tip">（关闭后，不出现在预约门店内）</span>
          </div>
        </el-form-item>
        <el-form-item label="预约状态：">
          <div class="flex item-center">
            <el-switch
              style="display: block"
              v-model="ruleForm.orderStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <span class="form-tip">（关闭后，无法接受线上预约）</span>
          </div>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
export default {
  components: { HmStep },
  data() {
    const patternContactInfo = function(rule, val, callback) {
      if (
        /^1[0-9]{10}$/.test(this.ruleForm.contactInfo) ||
        /^0\d{2,3}-?\d{7,8}$/.test(this.ruleForm.contactInfo)
      ) {
        callback();
      }
      return callback(new Error("请输入正确的联系方式"));
    }.bind(this);
    return {
      steps: [
        {
          link: "StoreList",
          name: "门店列表"
        },
        {
          link: "ServiceCategory",
          name: "服务分类列表"
        },
        {
          link: "ServiceList",
          name: "项目列表"
        },
        {
          link: "StaffList",
          name: "技师列表"
        }
      ],
      dialogFormVisible: false,
      pageSize: 10,
      currentRowId: "",
      mode: "",
      store: "",
      service: "",
      activeTab: 0,
      currentPage: 1,
      dateAndTime: [],
      name: "",
      ruleForm: {
        status: 1,
        orderStatus: 1,
        name: "",
        contacts: "",
        contactInfo: "",
        description: "",
        address: "",
        latitude: "",
        longitude: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入门店名称", trigger: "blur" },
          { max: 15, message: "长度应小于十五个字", trigger: "blur" }
        ],
        contacts: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
          { max: 10, message: "长度应小于十个字", trigger: "blur" }
        ],
        contactInfo: {
          required: true,
          trigger: "blur",
          validator: patternContactInfo
        },
        address: { required: true, message: "请输入门店地址", trigger: "blur" },
        latitude: {
          required: true,
          message: "请输入门店经度",
          trigger: "blur"
        },
        longitude: {
          required: true,
          message: "请输入门店纬度",
          trigger: "blur"
        }
      }
    };
  },
  computed: mapGetters(["storeList"]),
  watch: {},
  mounted() {
    this.queryList();
  },
  methods: {
    step() {},
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryStoreList", {
        name: this.name,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toAddStore() {
      this.mode = "add";
      this.dialogFormVisible = true;
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.currentRowId = row.id;
      this.mode = "edit";
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
    },
    copy(row) {
      this.dialogFormVisible = true;
      this.currentRowId = row.id;
      this.mode = "copy";
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("deleteStore", { id }).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "删除门店成功！",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    submitForm(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          let actionName;
          let params = this.ruleForm;
          if (this.mode === "add" || this.mode === "copy") {
            actionName = "addStore";
          } else if (this.mode === "edit") {
            actionName = "editStore";
            params = Object.assign(this.ruleForm, { id: this.currentRowId });
          }
          this.$store.dispatch(actionName, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.resetForm(formname);
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formname) {
      this.$refs[formname].resetFields();
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
      this.ruleForm.status = 1;
      this.ruleForm.orderStatus = 1;
      this.dialogFormVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.link {
  width: 120px;
  margin-left: 10px;
  a {
    color: #2d8cf0;
  }
}
</style>
